import client from "api/config";
import { convertNum } from "helper/convert-num";

////////////////// work samples ////////////
const work_samples_url = "/work_samples";

// get all worksamples
export const getWorkSamplesDataRequest = (values) =>
  client.get(
    `${work_samples_url}?skip=${values.skip ? values.skip : 0}&limit=${
      values.limit ?? 10
    }${values.search ? "&search=" + convertNum(values.search) : ""}`
  );

// get worksample by id
export const getWorkSampleByIdRequest = (values) =>
  client.get(`${work_samples_url}/${values.id}`);

// add worksample
export const addWorkSampleRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.description && formData.append("description", values.description);
  values.link && formData.append("link", values.link);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  !values.image.isWeb && formData.append("image", values.image.url);
  return client.post(`/admin${work_samples_url}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const editWorkSampleRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.description && formData.append("description", values.description);
  formData.append("link", values.link);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  !values.image.isWeb && formData.append("image", values.image.url);
  return client.post(
    `/admin${work_samples_url}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

export const deleteWorkSampleByIdRequest = (values) =>
  client.delete(`/admin${work_samples_url}/${values}`);

/////// worksamples category
const work_sample_categories_url = "/work_sample_categories";
export const getWorkSampleCategoryRequest = (values) =>
  client.get(
    `${work_sample_categories_url}?skip=${
      values.skip ? values.skip : 0
    }&limit=${values.limit ?? 10}${
      values.search ? "&search=" + convertNum(values.search) : ""
    }`
  );

export const getWorkSamplesCategoryByIdRequest = (values) =>
  client.get(`${work_sample_categories_url}/${values.id}`);
export const addWorkSamplesCategoryRequest = (values) =>
  client.post(`/admin${work_sample_categories_url}`, values);
export const editWorkSamplesCategoryRequest = (values) =>
  client.put(`/admin${work_sample_categories_url}/${values.id}`, values);
export const deleteWorkSamplesCategoryByIdRequest = (id) =>
  client.delete(`/admin${work_sample_categories_url}/${id}`);
